{
  "add": "添加",
  "age": {
    "range": {
      "ADULT": "成年人",
      "BABY": "婴儿",
      "CHILD": "儿童",
      "SENIOR": "老年人",
      "TURNING_SENIOR": "即将步入老年",
      "YOUNG_ADULT": "青少年",
      "YOUTH": "少年"
    },
    "unknown": "年龄不详",
    "years": "{{ years }} 岁"
  },
  "ages": {
    "ADULT": "(21-63岁) 成年人",
    "BABY": "(0-1岁) 婴儿",
    "CHILD": "(1-5岁) 儿童",
    "SENIOR": "(65岁以上) 老年人",
    "TURNING_SENIOR": "(64岁) 即将步入老年",
    "YOUNG_ADULT": "(19-20岁) 青少年",
    "YOUTH": "(6-18岁) 少年"
  },
  "back": "返回",
  "cancel": "取消",
  "childCaregiverStatus": {
    "CAREGIVER": "是",
    "NOT_CAREGIVER": "否"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "符合条件的移民身份（绿卡等）",
    "NOT_ANSWERED": "不愿透露",
    "US_CITIZEN": "美国公民",
    "US_NATIONAL": "美国国民"
  },
  "clear": "清除",
  "clearAddress": "清除地址",
  "clearFilters": "清除筛选",
  "clinic": "诊所",
  "close": "关闭",
  "continue": "继续",
  "dateOfBirth": "出生日期",
  "datePicker": {
    "placeholder": "选择日期",
    "required": "请选择日期。"
  },
  "datetime": {
    "daysWithCount_one": "{{count}} 天",
    "daysWithCount_other": "{{count}} 天",
    "monthsWithCount_one": "{{count}} 个月",
    "monthsWithCount_other": "{{count}} 个月",
    "yearsWithCount_one": "{{count}} 年",
    "yearsWithCount_other": "{{count}} 年"
  },
  "day": "日",
  "delete": "删除",
  "discardFormChangesDialog": {
    "cancelButton": "返回继续编辑",
    "confirmButton": "坚持离开",
    "creating": "创建",
    "description": "您正在{{action}}的{{entity}}还有未保存的更改。如果您离开此页面，进度将会丢失。",
    "entity": "信息",
    "title": "确定要离开吗？",
    "updating": "编辑"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "移民身份证明",
    "PROOF_OF_EXEMPTION": "豁免证明",
    "PROOF_OF_EXPENSE": "支出证明",
    "PROOF_OF_IDENTITY": "身份证明",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "收入与就业证明",
    "PROOF_OF_INSURANCE": "雇主担保保险或其他保险证明",
    "PROOF_OF_RESIDENCE": "居住证明",
    "PROOF_OF_WORK": "工作证明",
    "SOCIAL_SECURITY_NUMBER": "社会安全号码 (SSN)"
  },
  "documentTypes": {
    "ALIMONY_PAID": "支付的赡养费",
    "AUTHORIZED_EMPLOYMENT_ID": "工作授权身份证件",
    "BANK_STATEMENTS": "银行对账单",
    "BIRTH_CERTIFICATE": "出生证明",
    "CHILDCARE": "育儿费",
    "CHILDS_BIRTH_CERTIFICATE": "子女出生证明",
    "CHILDS_PASSPORT": "子女护照",
    "COURT_ORDERED_STATEMENTS": "法院命令文件",
    "DOCTORS_NOTE": "医生证明",
    "DRIVERS_LICENSE": "驾照",
    "EXPENSE_OTHER": "其他",
    "FOSTER_CARE_VERIFICATION_LETTER": "寄养证明信",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "监护权或抚养权文件",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "移民文件与批准函",
    "INSURANCE_CARD": "保险卡",
    "INSURANCE_CARRIER_INFO": "保险公司信息（名称与地址）",
    "INSURANCE_POLICY_NUMBER": "保险单号",
    "IRA_CONTRIBUTIONS": "IRA 个人退休账户存款",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "雇主证明信",
    "MEDICAL_EXPENSE": "医疗支出",
    "MEDICARE_CARD": "Medicare 卡",
    "MORTGAGE_STATEMENT": "抵押贷款对账单",
    "MOVING_EXPENSES": "搬家费",
    "PASSPORT": "护照",
    "PAY_STUBS": "工资单（最近 30 天）",
    "PENSION_STATEMENTS": "退休金账单",
    "PROPERTY_TAX_BILL": "房产税账单",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "获释或出狱文件",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "租金收据或租赁协议",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "在学证明或成绩单",
    "SIGNED_LETTER": "已签字的信函",
    "SIGNED_TIMESHEETS": "已签字的工时表",
    "SNAP_TANF_VERIFICATION_LETTER": "SNAP/TANF 证明信",
    "SOCIAL_SECURITY_CARD": "社会安全卡",
    "SSA_STATEMENTS": "社会安全福利 (SSA) 账单",
    "SSDI_STATEMENTS": "伤残保险 (SSDI) 账单",
    "STATE_ID": "州身份证 (State ID)",
    "STUDENT_LOANS": "学生贷款",
    "TAX_RETURN": "纳税申报表（最近一年）",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "培训或学徒项目注册证明",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "治疗项目参加证明信",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "部落成员卡或证明信",
    "TUITION_FEES": "学费",
    "UNEMPLOYMENT_STATEMENTS": "失业救济账单",
    "USCIS_ID": "USCIS 身份证件（非公民）",
    "UTILITY_BILL": "水电燃气费账单",
    "VA_DISABILITY_RATING_LETTER": "VA 残障评级信函",
    "W2_FORMS": "W-2 表格",
    "descriptions": {
      "ALIMONY_PAID": "离婚或分居协议",
      "AUTHORIZED_EMPLOYMENT_ID": "由 USCIS 颁发的工作授权文件",
      "BANK_STATEMENTS": "最近 30 天内的支票或储蓄账户对账单",
      "BIRTH_CERTIFICATE": "带有您姓名和出生日期的美国出生证明",
      "CHILDCARE": "银行对账单、收据或您育儿服务提供者出具的信函",
      "CHILDS_BIRTH_CERTIFICATE": "带有您子女姓名和出生日期的出生证明",
      "CHILDS_PASSPORT": "带有您子女姓名和出生日期的美国护照",
      "COURT_ORDERED_STATEMENTS": "关于子女抚养费、赡养费或工伤赔偿的法院命令",
      "DOCTORS_NOTE": "医生出具的信函，说明此项豁免所依据的疾病、残障或怀孕情况",
      "DRIVERS_LICENSE": "带有您姓名、出生日期和地址的有效驾照",
      "EXEMPTION_SSA_STATEMENTS": "显示您所照护者社会安全福利的信函",
      "EXEMPTION_SSDI_STATEMENTS": "显示您所照护者残障福利的信函",
      "EXPENSE_OTHER": "显示付款金额的法院命令或书面协议",
      "FOSTER_CARE_VERIFICATION_LETTER": "州寄养机构出具的、确认您的身份状况和年龄的信函",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "显示您是该儿童法定照护者的法院命令或抚养权文件",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "工作许可、签证或其他显示您身份的 USCIS 文件",
      "IMMIGRATION_BIRTH_CERTIFICATE": "带有您姓名和出生日期的出生证明",
      "IMMIGRATION_PASSPORT": "带有您姓名和出生日期的护照",
      "INSURANCE_CARD": "带有保险公司名称和保单号的保险卡正反面",
      "INSURANCE_CARRIER_INFO": "带有保险公司名称和地址的文件",
      "INSURANCE_POLICY_NUMBER": "显示您保险单号或成员 ID 编号的文件",
      "IRA_CONTRIBUTIONS": "您的银行或 IRA 提供方出具的账单",
      "I_20": "由您学校出具、证明您可以在美国学习的纸质表格",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "确认您工作及薪资的证明信",
      "MEDICAL_EXPENSE": "银行对账单，或您的医生、医院或药房出具的账单或收据",
      "MEDICARE_CARD": "显示您已参加 Medicare A 部分和/或 B 部分的 Medicare 卡",
      "MORTGAGE_STATEMENT": "最近 60 天内带有您地址的抵押贷款账单",
      "MOVING_EXPENSES": "搬家收据和您雇主出具的信函",
      "PASSPORT": "带有您姓名和出生日期的美国护照",
      "PAY_STUBS": "最近 30 天内显示税前收入和雇主信息的工资单",
      "PENSION_STATEMENTS": "显示您每月退休金金额的账单",
      "PROPERTY_TAX_BILL": "带有您地址的房产税账单",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "显示您从看守所或监狱获释日期的文件",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "显示您当前地址的租金收据或租约",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "显示您至少为半日制在读的信函或成绩单",
      "SIGNED_LETTER": "确认培训、上学、学徒或社区服务的信函",
      "SIGNED_TIMESHEETS": "由您的雇主或主管签字、显示工作时数的工时表",
      "SNAP_TANF_VERIFICATION_LETTER": "SNAP 或 TANF 办公室出具的、确认您符合其工作要求的信函",
      "SOCIAL_SECURITY_CARD": "带有您姓名和 9 位社会安全号码的卡片",
      "SSA_STATEMENTS": "显示您每月社会安全福利金额的信函",
      "SSDI_STATEMENTS": "显示您每月残疾福利金额的信函",
      "STATE_ID": "带有您姓名、出生日期和地址的有效州身份证",
      "STUDENT_LOANS": "您的银行或贷款服务机构出具的账单",
      "TAX_RETURN": "去年的完整纳税申报表",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "显示您已参加培训或学徒项目的证书或信函",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "确认您正在参加戒毒或戒酒治疗项目的信函",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "确认您成员身份的部落身份证或信函",
      "TUITION_FEES": "您学校出具的收据或账单",
      "UNEMPLOYMENT_STATEMENTS": "显示您每周或每月失业救济金额的信函",
      "USCIS_ID": "绿卡、工作许可或公民证书",
      "UTILITY_BILL": "最近 60 天内带有您地址的电费、燃气费、水费或电话费账单",
      "VA_DISABILITY_RATING_LETTER": "显示您 100% 残障评级的 VA 信函",
      "W2_FORMS": "显示您的雇主和工资的最新 W-2 表格"
    }
  },
  "documents": {
    "choosePhoto": "选择照片",
    "takePhoto": "拍照"
  },
  "done": "完成",
  "edit": "编辑",
  "email": "电子邮箱",
  "error": "错误",
  "errorFallback": {
    "description": "加载此页面时出现问题。",
    "resetCta": "重试",
    "title": "出错了。"
  },
  "errors": {
    "appleSsoNotSupported": "无法使用 Apple 登录。请尝试其他登录方式。",
    "emptyHomeAddress": "请输入并选择您的住址，或勾选无固定居住地址。",
    "emptyMailingAddress": "请输入并选择邮寄地址，或勾选无邮寄地址。",
    "googleSsoNotSupported": "无法使用 Google 登录。请尝试其他登录方式。",
    "invalidEmail": "请输入有效的电子邮箱（例如：name@example.com）。",
    "selectValidOption": "请选择一个有效的选项。",
    "unableToCreateApplications": "无法提交您的申请。请检查网络并重试。",
    "unauthenticated": "请登录以继续。",
    "unauthorized": "您没有登录权限。如有误，请联系 support@pointcare.com。",
    "unknown": "出错了。请重试。"
  },
  "exit": "退出",
  "female": "女",
  "filesWithCount_one": "{{count}} 个文件",
  "filesWithCount_other": "{{count}} 个文件",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "通过工作的医疗保险（雇主担保）",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "其他",
    "PRIVATE": "私人保险或 ACA 医疗保险 Marketplace",
    "TRICARE": "TRICARE（现役/退伍军人医疗保障）",
    "VA": "退役军人部 (VA) 医疗服务"
  },
  "home": "首页",
  "householdMember": "家庭成员",
  "listConnector": "和",
  "listSeparator": "、",
  "loading": "加载中...",
  "login": {
    "checkYourEmail": "请在您的邮箱 {{email}} 中查收登录链接。",
    "placeholder": "name@example.com",
    "sendEmail": "发送邮件"
  },
  "longDateFormat": "YYYY年M月D日",
  "male": "男",
  "maritalStatus": {
    "COMMON_LAW": "事实婚姻",
    "DIVORCED": "离婚",
    "MARRIED": "已婚",
    "NEVER_MARRIED": "从未结婚",
    "REGISTERED_DOMESTIC_PARTNER": "注册同居伴侣",
    "SEPARATED": "分居",
    "WIDOWED": "丧偶"
  },
  "marketplace": "ACA 医疗保险 Marketplace",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage（C 部分）",
    "NOT_SURE": "不确定",
    "ORIGINAL": "A 部分和 B 部分（Original）"
  },
  "member_one": "{{count}} 位成员",
  "member_other": "{{count}} 位成员",
  "month": "月",
  "next": "下一步",
  "no": "否",
  "noResults": "未找到结果",
  "noneOfTheAbove": "以上均无",
  "ok": "确定",
  "open": "打开",
  "or": "或",
  "pagination": {
    "goToFirstPage": "前往第一页",
    "goToLastPage": "前往最后一页",
    "goToNextPage": "下一页",
    "goToPreviousPage": "上一页",
    "morePages": "更多页面",
    "pagination": "分页",
    "rowsPerPage": "每页行数",
    "rowsResults": "显示 {{from}} 到 {{to}} 条，共 {{total}} 条结果",
    "showingPrefix": "正在显示 "
  },
  "payFrequency": {
    "ANNUALLY": "每年",
    "BI_WEEKLY": "每两周",
    "MONTHLY": "每月",
    "WEEKLY": "每周"
  },
  "pdfViewer": {
    "loading": "正在加载文件..."
  },
  "program_one": "{{count}} 个项目",
  "program_other": "{{count}} 个项目",
  "progressIndicator": "进度：已完成 {{total}} 中的 {{progress}}",
  "relationships": {
    "CHILD": "孩子",
    "FOSTER_CHILD": "寄养儿童",
    "GRANDCHILD": "孙子女",
    "GRANDPARENT": "祖父母",
    "OTHER": "其他",
    "PARENT": "父母",
    "PARTNER": "伴侣",
    "SIBLING": "兄弟姐妹",
    "SPOUSE": "配偶",
    "STEPCHILD": "继子女"
  },
  "required": "此项为必填项。",
  "returnToDashboard": "返回控制面板",
  "save": "保存",
  "saveChanges": "保存更改",
  "share": "分享",
  "sidebar": {
    "title": "侧边栏",
    "toggle": "切换侧边栏"
  },
  "signOut": "退出登录",
  "skip": "跳过",
  "stepIndicator": "第 {{currentStep}} 步，共 {{totalSteps}} 步",
  "submit": "提交",
  "tabs": {
    "home": "首页"
  },
  "taxFilingStatus": {
    "HEAD": "一家之主 (Head of Household)",
    "JOINTLY": "夫妻合报",
    "NON_FILER": "无需报税",
    "SEPARATELY": "夫妻分报",
    "SINGLE": "单身",
    "WIDOWER": "带抚养子女的合格遗孀/鳏夫"
  },
  "theme": "主题",
  "time": {
    "am": "上午",
    "pm": "下午"
  },
  "undo": "撤销",
  "unknown": "未知",
  "uploadButton": {
    "title": "上传文件或拍照"
  },
  "validation": {
    "atLeastOneOption": "请至少选择一个选项。",
    "genericError": "操作失败。请重试。",
    "invalidCode": "验证码不匹配。请检查或申请新验证码。",
    "invalidEmail": "请输入有效的电子邮箱（例如：name@example.com）。",
    "invalidNumber": "请输入有效的数字。",
    "invalidPassword": "密码错误。请重试。",
    "invalidPhone": "请输入 10 位电话号码。",
    "invalidSsn": "您的社会安全号码应仅包含数字（不含连字符或空格）。",
    "invalidSsnFormat": "这不是有效的社会安全号码。请检查后重试。",
    "invalidSsnLength": "请输入您的 9 位社会安全号码。",
    "numberMustBeNonNegative": "请输入大于或等于 0 的数字。",
    "passwordMismatch": "两次输入的密码不一致。",
    "requiredField": "请填写此项。",
    "requiredFields": "请填写所有必填项。",
    "requiredNonNegative": "请输入大于或等于 0 的数字。",
    "requiredPassword": "请输入您的密码。",
    "unknown": "出错了。请重试。"
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "输入您的电子邮件以完成登录",
    "verify": "验证",
    "verifyError": "我们无法验证您的登录链接。链接可能已过期。请申请新链接。"
  },
  "whoApplies": "这适用于谁？",
  "whoIsApplying": "谁在申请？",
  "year": "年",
  "yes": "是",
  "zoom": "缩放",
  "zoomIn": "放大",
  "zoomOut": "缩小",
  "zoomReset": "重置缩放"
}
